import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { Drawer, DrawerContent, DrawerCloseButton, Box } from '@grupoboticario/flora-react'

import { theme } from '@/utils/themes/theme'
import { businessUnitTheme } from '@/utils/themes/themes'

import * as S from './ActionDrawer.styles'

const ActionDrawer = ({ onOpenChange, buttonTrigger, children }) => {
  const [themeProvider, setThemeProvider] = useState()
  const { pathname } = useLocation()

  useEffect(() => {
    setThemeProvider(theme(globalThis?.location?.hostname))
  }, [pathname])

  return (
    <Drawer onOpenChange={onOpenChange} side="right">
      {buttonTrigger}
      <DrawerContent>
        <Box className={businessUnitTheme[themeProvider] || ''}>
          <DrawerCloseButton css={S.closeButtonCss} />
          {children}
        </Box>
      </DrawerContent>
    </Drawer>
  )
}

export default ActionDrawer
